import { createSelector } from 'reselect';
import { WebInterfaceBaseState } from '../../../common/base/state';

const getLoadingProcessDetailsSelector = (state: WebInterfaceBaseState) =>
	state.modules.dashboard.widgets.processDetails.loading;

export const getLoadingProcessDetails = createSelector(
	[getLoadingProcessDetailsSelector],
	(loading: boolean): boolean => loading
);
